<script setup>
const { model } = defineProps(['model'])

const showSidebarNav = computed(
  () => model.menuSettingsBlock?.showSidebarNav?.value ?? false,
)

const mainBodyLayout = computed(
  () => showSidebarNav.value === true ? 'narrow' : 'wide',
)
</script>

<template>
  <div class="testimonial-page">
    <HeroBlock
      variation="small-image"
      :color="model.heroColor?.value"
      :title="model.pageTitle?.value"
      :description="model.pageSummary?.value"
      :image="model.aprimoTestimonialThumbnail?.url"
      :image-alt-text="model.testimonialThumbnailAltText?.value"
      :image-width="model.aprimoTestimonialThumbnail?.width"
      :image-height="model.aprimoTestimonialThumbnail?.height"
    />
    <div class="container-fluid">
      <div class="general-page__wrap">
        <LazyLayoutSidebarNav
          v-if="showSidebarNav"
          :id="model.contentLink?.id"
        />
        <div
          class="main-body"
          :class="`main-body--${mainBodyLayout}`"
        >
          <iframe
            v-if="model.youTubeUrl?.value"
            :title="model.testimonialName.value || model.pageTitle?.value || 'Patient testimonial video'"
            :src="model.youTubeUrl.value"
            allow="autoplay; encrypted-media"
            allowfullscreen
            class="aspect-video mx-auto mb-10 border-0"
            :class="{
              'w-full': mainBodyLayout === 'narrow',
              'w-full lg:w-5/6': mainBodyLayout !== 'narrow',
            }"
          />
          <div
            class="body-block-area w-full"
          >
            <div
              class="mx-auto w-full md:w-[80%] xl:max-w-[var(--body-width-narrow)]"
              :class="{
                'lg:w-[70%]': mainBodyLayout !== 'narrow',
              }"
            >
              <EditorialBlock
                :model="{ body: model.pageBody }"
              />
            </div>
            <TestimonialBlock
              :model="model"
            />
            <GenericsContentArea
              v-if="model.bodyBlockArea?.expandedValue"
              :model="model.bodyBlockArea.expandedValue"
            />
          </div>
        </div>
      </div>
      <div class="page-block-area flex flex-col items-center w-full">
        <GenericsContentArea
          v-if="model.pageBlockArea?.expandedValue"
          :model="model.pageBlockArea.expandedValue"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/pages/general-page.scss';
@use '@/assets/css/pages/testimonial-page.scss';
</style>
